import {Component, Input, OnInit} from '@angular/core';
import {ModalController, Platform} from "@ionic/angular";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";

@Component({
    selector: 'app-app-updates',
    templateUrl: './app-updates.component.html',
    styleUrls: ['./app-updates.component.scss'],
})
export class AppUpdatesComponent implements OnInit {
    @Input() title: string;
    @Input() messageNowBtn: string;
    @Input() messageAfterBtn: string;
    @Input() isMandatory: boolean = false;

    link: string
    linkIos: string = 'https://apps.apple.com/us/app/green-country/id1356426734'
    linkAndroid: string = 'https://play.google.com/store/apps/details?id=ua.com.greencountry.my';

    constructor(private platform: Platform, public myGcService: MyGreenCountry, private modalCtrl: ModalController) {
    }

    ngOnInit() {
        this.link = this.platform.is('android') ? this.linkAndroid : this.linkIos;
    }

    openUrl() {
        this.close().then(r => {
            this.myGcService.openUrl(this.link)
        })
    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }
}
